import { useSelector } from "react-redux";
import { accountSelector } from "../../../redux/account/accountSlice";
import NotificationEntriesPage from "../NotificationEntriesPage";

export default function MyNotificationsPage() {

    const baseUserInfo = useSelector(accountSelector)
    const { _id } = baseUserInfo

    return (
        <NotificationEntriesPage
            pageTitle="My Notifications"
            baseSlug={`my-notifications`}
            baseQuery={{ userId: _id }}
        />
    )
}